/* BUBBO scroll motion (see bubbo-scroll.css). No window scroll listeners: IntersectionObserver only. */
(function () {
  var doc = document.documentElement;
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (doc.classList.contains('bb-static') || doc.classList.contains('shopify-design-mode')) return;
  var touch = window.matchMedia('(hover: none)').matches;
  doc.classList.add('bb-scroll');
  if (touch) doc.classList.add('bb-touch');

  var SKIP = '.bb-hero, .bb-name-tag, .header, header, cart-drawer-component, .cart-drawer, .bb-mascot--peek, [data-bb-no-pop]';
  var HOT = '.bb-card, .bb-ages__tile, .bb-worlds__tile, .bb-cast-card, .bb-moment';

  function blink(m) {
    m.classList.add('is-blinking');
    setTimeout(function () { m.classList.remove('is-blinking'); }, 180);
  }
  function hop(m) {
    if (!m || m._bbHop) return;
    m._bbHop = 1;
    m.classList.remove('is-hopping');
    void m.offsetWidth;
    m.classList.add('is-hopping');
    setTimeout(function () { m.classList.remove('is-hopping'); blink(m); }, 780);
    setTimeout(function () { m._bbHop = 0; }, 2400);
  }

  // 1. Mascots pop in once, staggered inside their group
  var popIO = new IntersectionObserver(function (entries) {
    var groups = new Map();
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      popIO.unobserve(e.target);
      var parent = e.target.closest('ul, .bb-container, section') || document.body;
      var i = groups.get(parent) || 0;
      groups.set(parent, i + 1);
      var m = e.target;
      m.style.setProperty('--bb-pop-i', Math.min(i, 6));
      m.classList.remove('bb-wait');
      m.classList.add('bb-pop');
      m.addEventListener('animationend', function done(ev) {
        if (ev.animationName !== 'bb-pop-in') return;
        m.removeEventListener('animationend', done);
        m.classList.remove('bb-pop');
        m.style.removeProperty('--bb-pop-i');
        setTimeout(function () { blink(m); }, 250);
      });
    });
  }, { threshold: 0.3 });

  // 2. Touch: hover moment while the element crosses the middle band of the screen
  var hotIO = touch ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      e.target.classList.toggle('is-hot', e.isIntersecting);
      if (e.isIntersecting) hop(e.target.querySelector('.bb-mascot:not(.bb-name-tag .bb-mascot)') || e.target.querySelector('.bb-mascot'));
    });
  }, { rootMargin: '-38% 0px -38% 0px', threshold: 0 }) : null;

  function scan(scope) {
    (scope || document).querySelectorAll('.bb-mascot').forEach(function (m) {
      if (m._bbScroll || m.closest(SKIP)) return;
      if (m.getBoundingClientRect().width < 40) return;
      m._bbScroll = 1;
      m.classList.add('bb-wait');
      popIO.observe(m);
    });
    if (hotIO) (scope || document).querySelectorAll(HOT).forEach(function (el) {
      if (el._bbHot) return;
      el._bbHot = 1;
      hotIO.observe(el);
    });
  }
  function boot() { scan(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
  // Safety: anything still waiting after 4s shows itself (e.g. off-screen layout quirks)
  setTimeout(function () {
    document.querySelectorAll('.bb-mascot.bb-wait').forEach(function (m) {
      var r = m.getBoundingClientRect();
      if (r.width === 0 && r.height === 0) m.classList.remove('bb-wait');
    });
  }, 4000);
})();
